export const EXTENSIONS = ['.js', '.ts', '.tsx', '.jsx', '.mjs', '.cjs'];
export const SRC_MAIN = 'main';
export const SRC_ENTRIES = 'entries';

// Some file and dir names for dist
// We may change this in the future
export const DIST_ENTRIES_JS = 'entries.js';
export const DIST_SERVE_JS = 'serve.js';
export const DIST_PUBLIC = 'public';
export const DIST_ASSETS = 'assets';
export const DIST_SSR = 'ssr';
